import { createContext, type PropsWithChildren } from "react";
import { useModal } from "ui/atoms/Modal";

export const UploadSettlementContext = createContext({} as ReturnType<typeof useModal>);

const UploadSettlementProvider = ({ children }: PropsWithChildren) => (
    <UploadSettlementContext.Provider
        value={useModal()}
    >
        {children}
    </UploadSettlementContext.Provider>
);

export default UploadSettlementProvider;
